// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__TO0AV","rotate":"loading_rotate__u4ak9","animate":"loading_animate__Js1u2"};